@for (position of toastsByPosition(); track $index) {
	<div [class]="position.class">
		@for (toast of position.toasts; track toast.id) {
			<lbca-toast [toast]="toast" class="toast-slide-animation" />
		}
	</div>
}
